var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 12,
    viewBox: "0 0 37 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1033_36218",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 12
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.12 3.89691C19.0994 5.52168 20.5679 6.42843 21.6743 6.96749C22.8109 7.52064 23.1927 7.87532 23.1884 8.36991C23.1797 9.12697 22.2816 9.46104 21.4411 9.47405C19.9746 9.49683 19.1221 9.07817 18.4442 8.76146L17.916 11.2333C18.5961 11.5468 19.8553 11.8201 21.1612 11.832C24.2264 11.832 26.2318 10.319 26.2427 7.97293C26.2546 4.99564 22.1244 4.83077 22.1526 3.49994C22.1623 3.09646 22.5474 2.66586 23.3912 2.55632C23.8088 2.501 24.9618 2.4587 26.2687 3.06067L26.7817 0.669066C26.0789 0.413095 25.1754 0.167969 24.0507 0.167969C21.1656 0.167969 19.1362 1.70163 19.12 3.89691ZM31.7114 0.374048C31.1517 0.374048 30.6799 0.700521 30.4695 1.20162L26.0909 11.6563H29.1538L29.7634 9.9719H33.5064L33.86 11.6563H36.5597L34.2038 0.374048H31.7114ZM32.1398 3.42185L33.0238 7.65839H30.6029L32.1398 3.42185ZM15.4062 0.374048L12.9918 11.6563H15.9105L18.3238 0.374048H15.4062ZM11.0883 0.374048L8.05027 8.05319L6.82139 1.52375C6.67714 0.794883 6.10771 0.374048 5.47538 0.374048H0.508875L0.439453 0.701604C1.459 0.922868 2.61738 1.27971 3.31913 1.6615C3.74864 1.89469 3.8712 2.0986 4.01221 2.65285L6.33982 11.6563H9.42449L14.1535 0.374048H11.0883Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1033_36218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M-3.34375 1.56139L32.2453 -11.5452L40.3417 10.4398L4.75298 23.5464",
    fill: "url(#paint0_linear_1033_36218)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1033_36218",
    x1: 3.71063,
    y1: 11.4779,
    x2: 34.1522,
    y2: 0.266743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.b5ab3adaa4dcf7e84c9f4e864d6798a8.svg";
export { ForwardRef as ReactComponent };